module.exports = __webpack_public_path__ + "static/media/achievement.a98e1e03.png";